import {
  drjInfoAlabang,
  drjInfoEarnshaw,
  drjInfoExperience
} from 'src/constants';
import { PCWorthBranchesEnum } from 'src/enums/branches';

// This is for offline getting the branch information. If you have an option to use API. Please do so.
export const getDrjInfoViaID = (id?: PCWorthBranchesEnum) => {
  switch (id) {
    case PCWorthBranchesEnum.LPC:
      return drjInfoAlabang;
    case PCWorthBranchesEnum.Earnshaw:
      return drjInfoEarnshaw;
    case PCWorthBranchesEnum.Experience:
      return drjInfoExperience;
    default:
      return drjInfoEarnshaw;
  }
};

export const getMostCommonBranchIdOnTransactionItems = (items: any) => {
  if (!items) {
    return null;
  }
  if (!items.length) {
    return null;
  }
  if (items?.length <= 0) {
    return null;
  }
  if (items.length === 1) {
    return items[0].branch_id;
  }
  const branchCounts: { branch_id?: number; qty: number }[] = [];

  for (const item of items) {
    const existing = branchCounts.find((b) => b.branch_id === item.branch_id);
    if (existing) {
      existing.qty += 1;
    } else {
      branchCounts.push({ branch_id: item.branch_id, qty: 1 });
    }
  }

  branchCounts.sort((a, b) => b.qty - a.qty);

  const topQty = branchCounts[0].qty;
  const topBranches = branchCounts.filter((b) => b.qty === topQty);

  if (topBranches.length > 1) {
    // Tie: pick the one that appears first in `items`
    return items.find((item: any) =>
      topBranches.some((b) => b.branch_id === item.branch_id)
    ).branch_id;
  }

  if (!topBranches) {
    return null;
  }

  if (topBranches?.length <= 0) {
    return null;
  }

  return topBranches[0].branch_id;
};
